import { useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import { Assessment, ViewList, MovieFilter, TrendingUp, AdminPanelSettings } from '@mui/icons-material';
import { useTranslation } from 'react-i18next';
import { AuthContext } from '../context/AuthContext';
import { admins } from '../Constants';

const ContentHubPage = () => {
    const navigate = useNavigate();
    const { t } = useTranslation('pages');
    const { user } = useContext(AuthContext);
    const isAdmin = !!user && admins.includes(user.steamID);

    const sections = [
        {
            title: t('contentHub.tierlist'),
            description: t('contentHub.tierlistDesc'),
            route: "/tierlist",
            icon: <ViewList style={{ fontSize: 48, color: '#ff6600' }} />,
            color: "border-warning"
        },
        {
            title: t('contentHub.statsview'),
            description: t('contentHub.statsviewDesc'),
            route: "/statsview",
            icon: <Assessment style={{ fontSize: 48, color: '#17a2b8' }} />,
            color: "border-info"
        },
        {
            title: t('contentHub.leaguestats'),
            description: t('contentHub.leaguestatsDesc'),
            route: "/leaguestats",
            icon: <TrendingUp style={{ fontSize: 48, color: '#28a745' }} />,
            color: "border-success"
        },
        {
            title: t('contentHub.clips'),
            description: t('contentHub.clipsDesc'),
            route: "/clips",
            icon: <MovieFilter style={{ fontSize: 48, color: '#dc3545' }} />,
            color: "border-danger"
        }
    ];

    return (
        <div className="container mt-4">
            <div className="row mb-4">
                <div className="col">
                    <h1 className="text-white mb-3 d-flex align-items-center">
                        <Assessment className="me-2" /> {t('contentHub.title')}
                    </h1>
                    <p className="text-white-50">
                        {t('contentHub.subtitle')}
                    </p>
                </div>
                {isAdmin && (
                    <div className="col-auto d-flex align-items-start">
                        <button
                            className="btn d-flex align-items-center gap-2"
                            style={{ background: 'linear-gradient(135deg, #ff6600, #ff9933)', color: '#fff', fontWeight: 600, borderRadius: 8, padding: '10px 18px' }}
                            onClick={() => navigate('/admin')}
                        >
                            <AdminPanelSettings fontSize="small" /> Admin
                        </button>
                    </div>
                )}
            </div>

            <div className="row g-4">
                {sections.map((section, index) => (
                    <div key={index} className="col-md-6 col-lg-3">
                        <div
                            className={`card bg-dark text-white h-100 ${section.color} border-2`}
                            style={{ cursor: 'pointer', transition: 'transform 0.2s' }}
                            onClick={() => navigate(section.route)}
                            onMouseEnter={(e) => e.currentTarget.style.transform = 'translateY(-5px)'}
                            onMouseLeave={(e) => e.currentTarget.style.transform = 'translateY(0)'}
                        >
                            <div className="card-body text-center d-flex flex-column">
                                <div className="mb-3">
                                    {section.icon}
                                </div>
                                <h5 className="card-title">{section.title}</h5>
                                <p className="card-text text-white-50 flex-grow-1">
                                    {section.description}
                                </p>
                                <button className="btn btn-outline-light btn-sm mt-3">
                                    {t('contentHub.viewMore')} →
                                </button>
                            </div>
                        </div>
                    </div>
                ))}
            </div>
        </div>
    );
};

export default ContentHubPage;
